import { EwayBill } from './../Model/EwayBill';
import { environment } from '../../environments/environment';
import { Injectable, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ExtendEwayBill } from '../Model/ExtendEwayBill';


@Injectable( {
  providedIn: 'root'
} )
export class LookupService
{

  constructor ( private _httpClient: HttpClient ) { }

  //============================================Eway bill service====================================
  SavePartyByEwayBill ( input: EwayBill ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "EwayBill", body, httpOptions );
  }

  ExtendEwayBill ( oExtendEwayBill: ExtendEwayBill ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( oExtendEwayBill );
    return this._httpClient.post( environment.WebserviceUrl + "EwayBillExtend", body, httpOptions );
  }


  GetEwayBillDetail ( ewaybillno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "EwayBill?ewaybillno=" + ewaybillno, httpOptions );
  }

  GetEwayBillDetailForExtend ( ewaybillno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "EwayBillExtend?ewaybillno=" + ewaybillno, httpOptions );
  }

  GetDistanceForExtend ( from_pincode: string, to_pincode: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "EwayBillExtend?from_pincode=" + from_pincode + "&to_pincode=" + to_pincode, httpOptions );
  }
}

